import {NotImplementedError} from '../error/not-implemented-error';

export abstract class WindowRef {
  public get nativeWindow(): Window | Record<string, unknown> {
    throw new NotImplementedError();
  }
}
